/* eslint-disable no-unreachable */
export const usersActions = {
  FILTERING: "FILTERING",
  INIT: "INIT",
  SORTING: "SORTING",
};

/**
 * Init items
 * @param {array} users
 * @param {object} meta
 * @param {number} meta.total_count
 * @param {number} meta.total
 * @param state
 * @return {object} new state
 */
const initItems = (users, meta, state) => {
  // rebuild campaign request in according to UI necessity
  state.pager.setTotal(meta);

  return {
    ...state,
    users,
  };
};

export const userGridReducer = (state, action) => {
  switch (action.type) {
    case usersActions.INIT:
      return initItems(action.data, action.pager, state);

    default:
      throw new Error("Method is not implemented");
  }
};
